import request, { Methods, withToken } from "../../../utils/request";
import { getUserCompany } from "../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_TYPES_PERSONNEL_ACTIONS_REQUEST = "GET_TYPES_PERSONNEL_ACTIONS_REQUEST";
export const GET_TYPES_PERSONNEL_ACTIONS_SUCCESS = "GET_TYPES_PERSONNEL_ACTIONS_SUCCESS";
export const GET_TYPES_PERSONNEL_ACTIONS_ERROR = "GET_TYPES_PERSONNEL_ACTIONS_ERROR";

//* ACTIONS ------------------------------------------------
export const getTypesPersonnelActionsRequest = (payload = {}, callback) => ({
  type: GET_TYPES_PERSONNEL_ACTIONS_REQUEST,
  payload,
  callback,
});

export const getTypesPersonnelActionsSuccess = (data) => ({
  type: GET_TYPES_PERSONNEL_ACTIONS_SUCCESS,
  payload: data,
});

export const getTypesPersonnelActionsError = (error) => ({
  type: GET_TYPES_PERSONNEL_ACTIONS_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getTypesPersonnelActionsServiceRequest = async () => {
  const options = await withToken({
    method: Methods.GET,
    headers: { CompanyId: await getUserCompany() },
  });
  return request(`/personnel_action_types`, options);
};
